import { render, staticRenderFns } from "./SizeRow.vue?vue&type=template&id=584eaf62"
import script from "./SizeRow.vue?vue&type=script&lang=js"
export * from "./SizeRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports